export default function AppProgressBar() {
  return (
    <div
      className={
        'fixed h-1.5 bg-app-green max-w-[500px] z-[1000] top-0 left-0 right-0 mx-auto app-progress-bar'
      }
    ></div>
  )
}
